// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0 105px;
}
@media (max-width: 992px) {
  .container {
    padding: 10px;
  }
}

.main-frame {
  width: 100%;
  max-width: 1300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 38px;
  padding-bottom: 28px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
@media (max-width: 992px) {
  .header {
    padding-top: 10px;
    flex-direction: column;
    justify-content: center;
  }
}
.header .header-left {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 10px;
}

.logo {
  color: #FFF;
  font-family: "SF Pro Rounded";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 106%;
  letter-spacing: -0.3px;
  margin-bottom: -5px;
  margin-left: 9px;
}

.header-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media (max-width: 992px) {
  .header-right {
    flex-direction: column;
  }
}

.contactBubble {
  position: relative;
  width: 295px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #C89BFF;
  color: #FFF;
  font-family: "SF Pro Rounded";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 106%;
  letter-spacing: -0.3px;
  padding: 10px 16px;
  margin-right: 16px;
}
@media (max-width: 992px) {
  .contactBubble {
    margin: 10px 0 10px 0;
  }
}
.contactBubble:after {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #C89BFF;
}
@media (max-width: 992px) {
  .contactBubble:after {
    display: none;
  }
}

.contactButton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFF5F5;
  padding: 12px 40px;
  height: 40px;
  border-radius: 90px;
  border: none;
  cursor: pointer;
  color: #AF6DFF;
  font-family: "SF Pro Rounded";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.3px;
  text-decoration-line: underline;
}

.mainContent {
  margin: auto 5% auto 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 992px) {
  .mainContent {
    flex-direction: column;
    margin: auto;
    margin-bottom: 0;
  }
}

.textContent {
  width: 390px;
  color: #FFF;
  font-family: "SF Pro Rounded";
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.3px;
}
@media (max-width: 992px) {
  .textContent {
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;
    width: 340px;
  }
}

.phoneMockup {
  width: 55%;
  height: 60%;
}
@media (max-width: 992px) {
  .phoneMockup {
    width: 40%;
    height: 45%;
  }
}
@media (max-width: 768px) {
  .phoneMockup {
    width: 60%;
    height: 65%;
  }
}
@media (max-width: 480px) {
  .phoneMockup {
    width: 70%;
    height: 75%;
  }
}

.footer {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 30px;
}
@media (max-width: 992px) {
  .footer {
    flex-direction: column;
    text-align: center;
  }
}
.footer-left {
  display: flex;
  flex-direction: column;
}
.footer-left-first {
  color: #FFF;
  font-family: "SF Pro Rounded";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 106%;
  letter-spacing: -0.3px;
}
.footer-left-second {
  max-width: 370px;
  color: #E0C7FF;
  font-family: "SF Pro Rounded";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 106%;
  letter-spacing: -0.3px;
  margin-top: 5px;
}
.footer-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.footer-right-first, .footer-right-second {
  color: #E0C7FF;
  text-align: right;
  font-family: "SF Pro Rounded";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 106%;
  letter-spacing: -0.3px;
}
@media (max-width: 992px) {
  .footer-right {
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;AACF;AACE;EATF;IAUI,aAAA;EAEF;AACF;;AACA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iDAAA;AAEF;AAAE;EARF;IASI,iBAAA;IACA,sBAAA;IACA,uBAAA;EAGF;AACF;AADE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAGJ;;AACA;EACE,WAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAEF;AAAE;EANF;IAOI,sBAAA;EAGF;AACF;;AAAA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAGF;AADE;EAhBF;IAiBI,qBAAA;EAIF;AACF;AAFE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;EACA,+BAAA;AAIJ;AAFI;EAZF;IAaI,aAAA;EAKJ;AACF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;AAIF;;AADA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAIF;AAFE;EANF;IAOI,sBAAA;IACA,YAAA;IACA,gBAAA;EAKF;AACF;;AADA;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAIF;AAFE;EATF;IAUI,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,YAAA;EAKF;AACF;;AAFA;EACE,UAAA;EACA,WAAA;AAKF;AAHE;EAJF;IAKI,UAAA;IACA,WAAA;EAMF;AACF;AAJE;EATF;IAUI,UAAA;IACC,WAAA;EAOH;AACF;AALE;EAdF;IAeI,UAAA;IACA,WAAA;EAQF;AACF;;AALA;EACE,8CAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAQF;AANE;EATF;IAUI,sBAAA;IACA,kBAAA;EASF;AACF;AAPE;EACE,aAAA;EACA,sBAAA;AASJ;AAPI;EACE,WAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AASN;AANI;EACE,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AAQN;AAJE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAMJ;AAJI;EACE,cAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAMN;AAHI;EAhBF;IAiBI,gBAAA;EAMJ;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  background-image: url('./assets/bg.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 0 105px;\n\n  @media (max-width: 992px) {\n    padding: 10px;\n  }\n}\n\n.main-frame {\n  width: 100%;\n  max-width: 1300px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; \n  padding-top: 38px;\n  padding-bottom: 28px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  \n  @media (max-width: 992px) {\n    padding-top: 10px;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .header-left {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    margin-bottom: 10px;\n  }\n}\n\n.logo {\n  color: #FFF;\n  font-family: \"SF Pro Rounded\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 106%;\n  letter-spacing: -0.3px;\n  margin-bottom: -5px;\n  margin-left: 9px;\n}\n\n.header-right {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 992px) {\n    flex-direction: column;\n  }\n}\n\n.contactBubble {\n  position: relative;\n  width: 295px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #C89BFF;\n  color: #FFF;\n  font-family: \"SF Pro Rounded\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 106%;\n  letter-spacing: -0.3px;\n  padding: 10px 16px;\n  margin-right: 16px;\n\n  @media (max-width: 992px) {\n    margin: 10px 0 10px 0;\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: -10px;\n    transform: translateY(-50%);\n    width: 0;\n    height: 0;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-left: 10px solid #C89BFF;\n\n    @media (max-width: 992px) {\n      display: none;\n    }\n  }\n}\n\n.contactButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #FFF5F5;\n  padding: 12px 40px;\n  height: 40px;\n  border-radius: 90px;\n  border: none;\n  cursor: pointer;\n  color: #AF6DFF;\n  font-family: \"SF Pro Rounded\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: -0.3px;\n  text-decoration-line: underline;\n}\n\n.mainContent {\n  margin: auto 5% auto 5%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (max-width: 992px) {\n    flex-direction: column;\n    margin: auto;\n    margin-bottom: 0;\n  }\n\n}\n\n.textContent {\n  width: 390px;\n  color: #FFF;\n  font-family: \"SF Pro Rounded\";\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n\n  @media (max-width: 992px) {\n    font-size: 30px;\n    text-align: center;\n    margin-bottom: 20px;\n    width: 340px;\n  }\n}\n\n.phoneMockup {\n  width: 55%;\n  height: 60%;\n\n  @media (max-width: 992px) {\n    width: 40%;\n    height: 45%;\n  }\n\n  @media (max-width: 768px) {\n    width: 60%;\n     height: 65%;\n  }\n\n  @media (max-width: 480px) {\n    width: 70%;\n    height: 75%;\n  }\n}\n\n.footer {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  margin-top: 0;  \n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 24px;\n  padding-bottom: 30px;\n\n  @media (max-width: 992px) {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  &-left {\n    display: flex;\n    flex-direction: column;\n\n    &-first {\n      color: #FFF;\n      font-family: \"SF Pro Rounded\";\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 106%;\n      letter-spacing: -0.3px;\n    }\n  \n    &-second {\n      max-width: 370px;\n      color: #E0C7FF;\n      font-family: \"SF Pro Rounded\";\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 106%;\n      letter-spacing: -0.3px;\n      margin-top: 5px; \n    }\n  }\n\n  &-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n\n    &-first, &-second {\n      color: #E0C7FF;\n      text-align: right;\n      font-family: \"SF Pro Rounded\";\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 106%;\n      letter-spacing: -0.3px;\n    }\n\n    @media (max-width: 992px) {\n      margin-top: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
